export default __webpack_public_path__ + "static/media/linker.1371212f.png";